module.exports = __webpack_public_path__ + "static/img/banner_1_no_red.0928e931.jpg";